import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { ServicePlanTerm } from 'src/features/servicePlanTerms/utils/types';
import { PatchServicePlanTermFormSchemaValues } from 'src/features/servicePlanTerms/utils/formSchema';

const RESOURCE = '/subscriptions/service-plan/:servicePlanId/service-plan-terms/:termId/';

type MutationFnType = typeof mutationFn;

interface DTO extends PatchServicePlanTermFormSchemaValues {
    servicePlanId: string;
    termId: string;
}

const mutationFn = ({ termId, servicePlanId, ...data }: DTO): Promise<ServicePlanTerm> => {
    return axios.patch(formatResourcePath(RESOURCE, { servicePlanId, termId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePatchServicePlanTerm };
